import ICancelaViagemDTO from '../entities/ICancelaViagem'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface ICancelaViagem {
  execute(params: ICancelaViagemDTO): Promise<boolean>
}

export default class CancelaViagemImpl implements ICancelaViagem {
  constructor(private readonly lotesRepository: ILoteRepository) {}

  public async execute(params: ICancelaViagemDTO): Promise<boolean> {
    const { status } = await this.lotesRepository.cancelaViagem(params)
    if (status === 200) {
      return true
    }
    return false
  }
}
